import {XMarkIcon} from "@heroicons/react/24/solid";
import React, {useState} from "react";
import CopyDataToClipboard from "../../../common/ui/copy-data-to-clipboard";

const instructionList = [
    {key: 'title', text: 'Add Title', cssClass: 'text-green-600'},
    {key: 'mainContent', text: 'Main Content', cssClass: 'text-green-600'},
    {key: 'expandMainContent', text: 'Expand Main Content', cssClass: 'text-green-600'},
    {key: 'sectionTitles', text: 'Select SECTION for Section Titles', cssClass: 'text-purple-600'},
    {key: 'expandSectionContent', text: 'Expand Sections', cssClass: 'text-purple-600'},
    {key: 'rewriteSectionTitles', text: 'Rewrite Section Titles', cssClass: 'text-purple-600'},
    {key: 'mainContentLinks', text: 'Add Links for Section Content', cssClass: 'text-purple-600'},
    {key: 'sectionContentLinks', text: 'Add Links for Section Content, if Needed', cssClass: 'text-purple-600'},
    {key: 'addImages', text: 'Add Images for Main Content', cssClass: 'text-blue-600'},
    {key: 'excerpts', text: 'Add Excerpts', cssClass: 'text-green-600'},
    {key: 'featuredImage', text: 'Design Featured Image', cssClass: 'text-blue-600'},
    {key: 'publishPost', text: 'Publish Post', cssClass: 'text-red-600'},
];

const ProductBlogPostInstructions = ({}) => {

    return (
        <>
            <div className={'p-4 border border-gray-400 bg-white shadow-lg rounded-xl'}>

                <div className={'text-lg text-purple-600 font-semibold mb-2'}>
                    Instructions
                </div>

                {instructionList?.map((instruction, instructionIndex) => (
                    <div key={`instruction-${instructionIndex}`}>
                        <div className={'flex items-center justify-between'}>
                            <div className={`flex justify-start ${instruction?.cssClass}`}>
                                <div className={''}>{instructionIndex + 1}.</div>
                                <div className={'ml-2'}>{instruction.text}</div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </>
    )
}

export default ProductBlogPostInstructions
